function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */

import React, { useContext, useEffect, useState } from "react";
import { isEmpty, isEqual } from "lodash";
import { Button, RadioButton, RadioButtonGroup, TextInput } from "@carbon/react";
import { Add, TrashCan } from "@carbon/react/icons";
import { i18nContext } from "../table-context";
var MAX_ENUM_LENGTH = 253;
function OptionInput(_ref) {
  var index = _ref.index,
    isInvalid = _ref.isInvalid,
    option = _ref.option,
    setOptions = _ref.setOptions;
  var i18n = useContext(i18nContext);
  var inputRef = React.useRef();
  useEffect(function () {
    if (option.isNew) {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    }
  }, []);
  var updateValue = function updateValue(event) {
    var newValue = event.target.value;
    setOptions(function (prevOptions) {
      return prevOptions.map(function (prevOption, i) {
        if (index === i) {
          return {
            selected: prevOption.selected,
            option: newValue
          };
        }
        return prevOption;
      });
    });
  };
  return /*#__PURE__*/React.createElement(TextInput, {
    id: "option-".concat(index, "-text"),
    invalid: !option.isNew && (isInvalid[index] || !option.option),
    invalidText: i18n.messages.enumOptionInvalid,
    labelText: "",
    maxLength: MAX_ENUM_LENGTH,
    onChange: updateValue,
    placeholder: i18n.messages.enumPlaceholder,
    ref: inputRef,
    value: option.option
  });
}
export default function EnumContent(_ref2) {
  var isNew = _ref2.isNew,
    property = _ref2.property,
    setValidationError = _ref2.setValidationError,
    updateProperty = _ref2.updateProperty;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isInit = _useState2[0],
    setIsInit = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    options = _useState4[0],
    setOptions = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    isInvalid = _useState6[0],
    setInvalid = _useState6[1];
  var i18n = useContext(i18nContext);
  var optionsValueArray = options.map(function (ele) {
    return ele.option;
  });
  useEffect(function () {
    // In nested panels use case, editing an enum was broken when this useEffect was called only on mount
    // Now for the edit use case, this useEffect watches for the first time "property" is altered and runs the initialisation steps
    // Or for the new enum use case, it runs the initialisation steps
    // The "isInit" state ensures that the initialisation steps are only run once
    // This pattern is also followed in AppConfigContent
    if (!isInit && (isNew || property && !isEmpty(property.value))) {
      var value = property.value;
      if (!value) {
        value = {
          "": true
        };
      }
      var initOptions = Object.keys(value).map(function (key) {
        return {
          isNew: !key,
          option: key,
          selected: value[key]
        };
      });
      setOptions(initOptions);
      setIsInit(true);
    }
  }, [property]);
  useEffect(function () {
    var newIsInvalid = _toConsumableArray(isInvalid);
    var changed = false;
    optionsValueArray.forEach(function (value, index) {
      var valueFirstOccur = optionsValueArray.findIndex(function (optionValue) {
        return optionValue === value;
      });
      // If value is empty set invalid to true. If value not empty check for duplicates
      var isOptionInvalid = value ? valueFirstOccur !== index : true;
      if (isOptionInvalid !== isInvalid[index]) {
        newIsInvalid[index] = isOptionInvalid;
        changed = true;
      }
    });
    changed && setInvalid(newIsInvalid);
    var value = {};
    var hasOneOptionSelected = false;
    options.forEach(function (element) {
      // ensure only one option is marked as true
      if (element.option) {
        var selected = element.selected && !hasOneOptionSelected;
        selected && (hasOneOptionSelected = true);
        value[element.option] = selected;
      }
    });

    // Only mark the property as dirty if the options have been edited
    if (options.length && !isEqual(value, property) && (!options[0].isNew || options.length > 1)) {
      updateProperty(_objectSpread(_objectSpread({}, property), {}, {
        value: value
      }));
    }
  }, [options]);
  useEffect(function () {
    var isValid = isInvalid.every(function (ele) {
      return !ele;
    });
    setValidationError("options", function () {
      return !isValid;
    });
  }, [isInvalid]);
  var deleteOption = function deleteOption(option, index) {
    var newOptions = _toConsumableArray(options);
    var newInvalid = _toConsumableArray(isInvalid);
    newOptions.splice(index, 1);
    newInvalid.splice(index, 1);
    if (option.selected) {
      newOptions[0].selected = true;
    }
    setOptions(newOptions);
    setInvalid(newInvalid);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioButtonGroup, {
    labelPosition: "right",
    legendText: i18n.messages.propertyValue,
    name: "radio-button-group",
    onChange: function onChange(selectedOption) {
      var selectedIndex = parseInt(selectedOption, 10);
      setOptions(function (prevOptions) {
        return prevOptions.map(function (option, index) {
          return _objectSpread(_objectSpread({}, option), {}, {
            selected: index === selectedIndex
          });
        });
      });
    },
    orientation: "vertical"
    // RadioButtonGroup falls back to `defaultSelected` if `valueSelected` is falsy,
    // so we can't use index as value otherwise UI will not display the first item as selected.
    // Also can't use option text as value since the RadioButton value is used as a `key` prop
    // internally in RadioButtonGroup and will cause the RadioButton to remount every time the
    // value changes making typing difficult as focus is lost.
    ,
    valueSelected: "".concat(options.findIndex(function (option) {
      return option.selected;
    }), "-option")
  }, options.map(function (option, index) {
    return /*#__PURE__*/React.createElement(RadioButton, {
      id: "option-".concat(index, "-radio"),
      key: "option-".concat(index),
      labelText: /*#__PURE__*/React.createElement("span", {
        className: "ocr--property-panel-enum-option"
      }, /*#__PURE__*/React.createElement(OptionInput, {
        index: index,
        isInvalid: isInvalid,
        option: option,
        setOptions: setOptions
      }), /*#__PURE__*/React.createElement(Button, {
        disabled: options.length < 2,
        hasIconOnly: true,
        iconDescription: i18n.messages["delete"],
        kind: "ghost",
        onClick: function onClick() {
          deleteOption(option, index);
        },
        renderIcon: TrashCan,
        size: "md",
        tooltipAlignment: "center",
        tooltipPosition: "top"
      })),
      value: "".concat(index, "-option")
    });
  })), /*#__PURE__*/React.createElement(Button, {
    id: "option-add-btn",
    kind: "ghost",
    onClick: function onClick() {
      setOptions(function (prevOptions) {
        return [].concat(_toConsumableArray(prevOptions), [{
          isNew: true,
          option: "",
          selected: false
        }]);
      });
    },
    renderIcon: Add
  }, i18n.messages.enumAdd));
}